import { isInIframe } from "shared/imports/sharedHelperFunctions"

export enum MessageTypes {
    COOKIE_CONSENT_STATUS = "COOKIE_CONSENT_STATUS",
    COOKIE_CONSENT_ACCEPTED = "COOKIE_CONSENT_ACCEPTED",
    GET_COOKIE_CONSENT = "GET_COOKIE_CONSENT",
    SET_COOKIE_CONSENT = "SET_COOKIE_CONSENT",
    CLEAR_COOKIE_CONSENT = "CLEAR_COOKIE_CONSENT",
}

export enum CookieCategories {
    ESSENTIAL = "essential",
    FUNCTIONAL = "functional",
    ANALYTICS = "analytics",
    ADVERTISING = "advertising",
}

export const COOKIE_CONSENT_NAME = "quorum_cookie_consent"
export const DEFAULT_COOKIE_CATEGORIES = [CookieCategories.ESSENTIAL]

export const setCookieConsent = (categories = DEFAULT_COOKIE_CATEGORIES) => {
    localStorage.setItem(COOKIE_CONSENT_NAME, JSON.stringify(categories))
}

export const getCookieConsent = () => {
    const consentCookie = localStorage.getItem(COOKIE_CONSENT_NAME)
    if (consentCookie) {
        try {
            return JSON.parse(consentCookie)
        } catch (e) {
            console.warn("Failed to parse quorum_cookie_consent:", e)
            return []
        }
    }
    return []
}

export const sendMessage = (message: Record<string, unknown>) => {
    if (!isInIframe()) return
    window.parent.postMessage(message, "*")
}

export const handleClearConsent = (requestId = null) => {
    if (isInIframe()) {
        window.location.reload()
        return
    }

    handleAcceptCategories([], requestId)
    if (window.loadThirdPartyScripts) window.loadThirdPartyScripts([])
}

export const handleAcceptCategories = (categories = DEFAULT_COOKIE_CATEGORIES, requestId = null) => {
    if (window.loadThirdPartyScripts) window.loadThirdPartyScripts(categories)
    sendMessage({
        type: MessageTypes.COOKIE_CONSENT_ACCEPTED,
        categories: categories,
        requestId: requestId,
    })
}

export const handleSendConsentStatus = (
    requestId: string | null = null,
    currentConsent: CookieCategories[] = DEFAULT_COOKIE_CATEGORIES,
) => {
    sendMessage({
        type: MessageTypes.COOKIE_CONSENT_STATUS,
        status: currentConsent,
        categories: currentConsent,
        requestId: requestId,
    })
}
